import { useEffect } from 'react';

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
};

export const useSeo = ({ title, description, image, url, jsonLd }) => {
  useEffect(() => {
    if (!title) return undefined;
    const previousTitle = document.title;
    document.title = title;

    const meta = (attr, key, value) => {
      if (!value) return null;
      const el = upsert(`meta[${attr}="${key}"]`, () => { const m = document.createElement('meta'); m.setAttribute(attr, key); return m; });
      const before = el.getAttribute('content');
      el.setAttribute('content', value);
      return () => el.setAttribute('content', before || '');
    };

    const restores = [
      meta('name', 'description', description),
      meta('property', 'og:title', title),
      meta('property', 'og:description', description),
      meta('property', 'og:image', image),
      meta('property', 'og:url', url || window.location.href),
      meta('name', 'twitter:card', 'summary_large_image'),
    ].filter(Boolean);

    const canonical = upsert('link[rel="canonical"]', () => { const l = document.createElement('link'); l.rel = 'canonical'; return l; });
    canonical.href = url || window.location.href;

    let script;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = previousTitle;
      restores.forEach(restore => restore());
      script?.remove();
    };
  }, [title, description, image, url, jsonLd]);
};
